import { z } from "zod";
import { groupIdSchema } from "../entities/group.js";
const filtersPrefillSchema = z.object({
  filters: z.object({ teammateGroupIds: z.array(groupIdSchema).min(1).optional() }).optional()
});
function buildTeammateGroupFilterSearch(groupId) {
  const prefill = { filters: { teammateGroupIds: [groupId] } };
  const search = new URLSearchParams({ prefill: JSON.stringify(prefill) });
  return `?${search.toString()}`;
}
function buildCustomerInteractionUrl(params) {
  const segments = [
    ...params.accountId ? buildCustomerPageSegments(params.playbookId, params.accountId) : ["performance", "playbooks", params.playbookId],
    "customer-interactions",
    params.gradingId
  ];
  const search = new URLSearchParams();
  const { target } = params;
  if (target?.tab === "assessment") {
    segments.push("assessment");
    if (target.criterionId) {
      segments.push("criteria", target.criterionId);
    }
  } else if (target?.tab === "transcript") {
    segments.push("transcript");
    if (target.quote) {
      search.set("quote", target.quote);
    }
  }
  const path = `/${segments.map(encodeURIComponent).join("/")}`;
  const query = search.toString();
  return query ? `${path}?${query}` : path;
}
function buildCustomerPageSegments(playbookId, accountId) {
  return ["performance", "playbooks", playbookId, "customers", accountId];
}
function buildCustomerPageUrl(params) {
  const segments = buildCustomerPageSegments(
    params.playbookId,
    params.accountId
  );
  return `/${segments.map(encodeURIComponent).join("/")}`;
}
function buildPlaybookTeammatesPath(playbookId) {
  const segments = ["performance", "playbooks", playbookId, "teammates"];
  return `/${segments.map(encodeURIComponent).join("/")}`;
}
function buildTeammatePageUrl(params) {
  const path = buildPlaybookTeammatesPath(params.playbookId);
  return `${path}/${encodeURIComponent(params.teammateId)}`;
}
function buildTeammateGroupPageUrl(params) {
  const path = buildPlaybookTeammatesPath(params.playbookId);
  return `${path}${buildTeammateGroupFilterSearch(params.groupId)}`;
}
export {
  buildCustomerInteractionUrl,
  buildCustomerPageUrl,
  buildTeammateGroupFilterSearch,
  buildTeammateGroupPageUrl,
  buildTeammatePageUrl,
  filtersPrefillSchema
};
//# sourceMappingURL=customerInteractionUrl.js.map
